module.exports = __webpack_public_path__ + "media/images/lb/185-5d084740a52b0fd50fd25418c35ebad2.svg";